import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { Route, Switch} from 'react-router-dom';
import { Container } from 'reactstrap';
import HomePage from './components/HomePage/HomePage';
import BuildInfo from './components/BuildInfo/BuildInfo';

class Routes extends Component {
  constructor(props) {
    super(props);
    autoBind(this);    
  }
  

    render() {
      return (   
        <Container fluid className="space-after-nav">       
          <Switch>
            <Route exact path='/' component={HomePage} />
            <Route exact path='/BuildInfo' component={BuildInfo} />
          </Switch>
        </Container>
      );
    }
  }

export default Routes;